import { useEffect, useState } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { api } from "../lib/api";
import { useSubscription } from "../context/SubscriptionContext";
import Layout from "../components/Layout";
import { CheckCircle2, Loader2, XCircle } from "lucide-react";

export default function BillingSuccess() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const { t } = useTranslation();
  const { refresh } = useSubscription();
  const [status, setStatus] = useState("checking");
  const [info, setInfo] = useState(null);
  const sessionId = params.get("session_id");

  useEffect(() => {
    if (!sessionId) return;
    let attempts = 0;
    const poll = async () => {
      try {
        const { data } = await api.get(`/billing/status/${sessionId}`);
        setInfo(data);
        if (data.payment_status === "paid") {
          setStatus("paid");
          await refresh();
        } else if (data.stripe_status === "expired") setStatus("expired");
        else if (attempts < 8) { attempts++; setTimeout(poll, 2000); }
        else setStatus("timeout");
      } catch { setStatus("error"); }
    };
    poll();
  }, [sessionId, refresh]);

  return (
    <Layout>
      <div className="max-w-xl mx-auto tray p-10 text-center" data-testid="billing-success">
        {status === "checking" && (
          <>
            <Loader2 className="w-12 h-12 text-amber-500 animate-spin mx-auto mb-4" />
            <h1 className="font-display text-3xl mb-2">{t("billing.verifying")}</h1>
            <p className="text-text-secondary">{t("billing.verifyingSub")}</p>
          </>
        )}
        {status === "paid" && (
          <>
            <CheckCircle2 className="w-14 h-14 text-emerald-400 mx-auto mb-4" />
            <h1 className="font-display text-4xl mb-2">{t("billing.subActive")}</h1>
            <p className="text-text-secondary mb-6">{t("billing.thankYou")}</p>
            <button onClick={() => navigate("/dashboard")} data-testid="billing-success-cta" className="btn-tactile btn-amber">
              {t("billing.goDashboard")}
            </button>
          </>
        )}
        {(status === "expired" || status === "timeout" || status === "error") && (
          <>
            <XCircle className="w-12 h-12 text-red-400 mx-auto mb-4" />
            <h1 className="font-display text-3xl mb-2">{t("billing.failed")}</h1>
            <p className="text-text-secondary mb-6">{t("billing.failedSub")}</p>
            <button onClick={() => navigate("/pricing")} className="btn-tactile">{t("common.retry")}</button>
          </>
        )}
      </div>
    </Layout>
  );
}
